import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FeedGhostblockPagination } from "web/types/serializers";

const feedGhostblockPagination = createSlice({
    name: "feedGhostblockPagination",
    initialState: {} as FeedGhostblockPagination,
    reducers: {
        storeGhostblockPagination(
            state,
            action: PayloadAction<FeedGhostblockPagination>
        ): FeedGhostblockPagination {
            state = action.payload;

            return state;
        },
    },
});

const { actions, reducer } = feedGhostblockPagination;

export const { storeGhostblockPagination } = actions;
export default reducer;
